import React from 'react';
import Button from '../../../shared/form/_Button';
import { Tooltip } from '../../../shared/_tooltip';
import PropTypes from 'prop-types';
import { injectStripe } from 'react-stripe-elements';
import connect from 'react-redux/es/connect/connect';
import { cardReplace } from '../../../../actions/PaymentDetailsActions';
import Spinner from '../../../shared/_Spinner';
import Modal from '../../../shared/_Modal';
import { tooltipEdit, tooltipHide } from '../../../../actions/tooltipActions';
import { _renderCardElement } from '../../../shared/stripe/_renderCardElement';
import { REPLACE_CARD_TOOLTIP_ID } from '../../../../constants/modals';

class ReplaceCardTooltip extends React.Component {
    _handleSubmit = (e) => {
      e.preventDefault();
      const { showModal, replaceCard, stripe } = this.props;

      if (!this._element._complete) {
        return;
      }
      showModal({ id: 'replacing-modal', status: 'loading' });
      stripe.createToken().then(({ token }) => {
        replaceCard(token);
      });
    };

    _handleSetCardValue = (c) => {
      this._element = c;
    };

    _handleCloseChargingModal = () => {
      const { hideModal } = this.props;

      hideModal({ id: REPLACE_CARD_TOOLTIP_ID });
      hideModal({ id: 'replacing-modal' });
    };

    _handleCloseChargingModalIfSuccess = () => {
      this.clearCardInfo();
      this._handleCloseChargingModal();
    };

    clearCardInfo = () => {
      this._element.clear();
    };

    render() {
      const { id, loading, onHandleHideTooltip, replacingModalStatus, error  } = this.props;

      return (
        <React.Fragment>
          <Tooltip className={ 'tooltip--card-replace' }
            header='Replace card'
            id={ id }
            onClose={ onHandleHideTooltip }>
            <form className={ 'form' } onSubmit={ this._handleSubmit }>
              {_renderCardElement({ onHandleSetCardValue: this._handleSetCardValue })}
              <div className={ 'replace-card__buttons' }>
                <Button className='form__button form__button--red' disabled={ loading } onClick={ onHandleHideTooltip }  type='button'>Cancel</Button>
                <Button className='form__button form__button--green' loading={ loading } type='submit'>Replace card</Button>
              </div>
            </form>
          </Tooltip>
          <Modal header='Replacing' id={ 'replacing-modal' }>
            { replacingModalStatus === 'loading' &&
              <React.Fragment>
                <h1>Card replace processing</h1>
                <Spinner enabled={ true } />
              </React.Fragment>
            }
            { replacingModalStatus === 'success' &&
              <React.Fragment>
                <h1>Congratulation!</h1>
                <div>You replaced your credit card</div>
                <br />
                <Button className='form__button--green' onClick={ this._handleCloseChargingModalIfSuccess } type={ 'button' } >Close</Button>
              </React.Fragment>
            }
            { replacingModalStatus === 'error' &&
              <React.Fragment>
                <h1>Error!</h1>
                <div>{error}</div>
                <br />
                <Button className='form__button--green' onClick={ this._handleCloseChargingModal } type={ 'button' } >Close</Button>
              </React.Fragment>
            }
          </Modal>
        </React.Fragment>
      );
    }
}

ReplaceCardTooltip.propTypes = {
  error: PropTypes.string,
  hideModal: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  onHandleHideTooltip: PropTypes.func.isRequired,
  replaceCard: PropTypes.func.isRequired,
  replacingModalStatus: PropTypes.string,
  showModal: PropTypes.func.isRequired,
  stripe: PropTypes.shape({
    createToken: PropTypes.func.isRequired
  })
};

const mapStateToProps = (state) => {
  return {
    replacingModalStatus: state.getIn(['tooltip', 'data', 'replacing-modal', 'status']),
    error: state.getIn(['paymentDetails', 'error']) && state.getIn(['paymentDetails', 'error']).response.body.message
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideModal: ({ id }) => dispatch(tooltipHide({ id })),
    showModal: ({ id, status }) => dispatch(tooltipEdit({ id, status })),
    replaceCard: (params) => dispatch(cardReplace(params))
  };
};

const withRedux = connect(mapStateToProps, mapDispatchToProps)(ReplaceCardTooltip);

export default injectStripe(withRedux);



// WEBPACK FOOTER //
// ./app/components/reps/settings/paymentMethods/_ReplaceCardTooltip.jsx